module.exports = __webpack_public_path__ + "static/img/correct-s.a5bd0ea1.svg";